export default "__VITE_ASSET__a7nVz6Cm__"